/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.errorModule', ['bulbApp.modalModule'])

/**
 * BulbErrorService encapsulates error reporting.
 */
.service('BulbErrorService', ['$log', 'BulbModalService', BulbErrorService]);

function BulbErrorService($log, BulbModalService) {
  /**
   * Report error.
   * @param message Caller's error message: should describe what caller was trying to do when the error occurred.
   * @param error The error that occurred.
   * @return The error message logged.
   */
  this.error = function(message, error) {
    var errorMessage = message || 'Server error';
    if (error) {
      if (error.data && error.data.developerMessage) {
        errorMessage += ': Error: ' + error.data.developerMessage;
      } else if (error.message) {
        errorMessage += ': Error: ' + error.message;
      } else if (error.statusText) {
        errorMessage += ': Error: ' + error.statusText;
      } else if (error.status) {
        errorMessage += ': ' + error.status;
      }
    }
    $log.error(errorMessage);
    return errorMessage;
  };

  /**
   * Display a modal dialog for the error.
   * @param message Message to display to override the default error message.  null will display the default.
   * @param error Error returned from a server request.  Will be used to log error information to the console.
   * @returns {*} The promise for the error dialog so the caller can proceed after the message is displayed.
   */
  this.showError = function(message, error) {
    if (message || error) {
      this.error(message, error);
    }

    // DO LATER : should some class be added to the dialog so the error can be styled differently?
    var modalOptions = {
      titleCode: 'server_error_title',
      showOkButton: false,
      showCancelButton: false
    };

    // FUTURE : this always uses the passed in message, or a default message, and never one passed from the server.
    // Should probably be a way to use the server message.
    if (message) {
      modalOptions.bodyText = message;
    } else {
      modalOptions.bodyCode = 'server_error_title';
    }

    return BulbModalService.show(modalOptions);
  };
}

